class MFRSectionWave {
  constructor(i, e, o) {
    this.$index = i
    this.$element = $(e)
    this.$options = o

    this.init()
  }

  init() {
    this.__handleLottieWaveColor()
  }

  __handleLottieWaveColor() {
    const animation = lottie.loadAnimation({
      container: this.$options.container, // the dom element that will contain the animation
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: this.$options.wave // the path to the animation json
    });
  }
}